const hubs = [
    {
        name: "Accelerators",
        icon: "/img/Accelerators.svg",
        pin: "/img/pins/pin-1.svg",
    },
    {
        name: "Incubators",
        icon: "/img/Incubators.svg",
        pin: "/img/pins/pin-2.svg",
    },
    {
        name: "R&D centres",
        icon: "/img/R&D centres.svg",
        pin: "/img/pins/pin-3.svg",
    },
    {
        name: "Coworking spaces",
        icon: "/img/Coworking spaces.svg",
        pin: "/img/pins/pin-4.svg",
    },
    {
        name: "Knowledge institutions",
        icon: "/img/Knowledge institutions.svg",
        pin: "/img/pins/pin-5.svg",
    },
];

const iconsByHubName = hubs.reduce((acc, x) => {
    acc[x.name] = x.icon;
    return acc;
}, {});
const pinsByHubName = hubs.reduce((acc, hub) => {
    acc[hub.Name] = hub.pin;
    return acc;
}, {});
export const hubByName = hubs.reduce((acc, hub) => {
    acc[hub.Name] = hub;
    return acc;
}, {});
// Use black pin as default
export const getIcon = hubName => {
    return iconsByHubName[hubName] || "/img/black-pin.svg";
};
export const getPin = hubName => {
    return pinsByHubName[hubName] || "/img/black-pin.svg";
};



// WEBPACK FOOTER //
// ./src/modules/hub.js